"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bigmath_1 = require("../bigmath");
const smap_1 = require("../smap");
function maxCraftByAssemblerSpeed(game, state, item) {
    const pairs = (0, smap_1.mapPairs)(state.assemblers[item], (numAssemblers, assemblerName) => {
        const boostingItem = game.buildingBoosts[assemblerName];
        if (!boostingItem)
            return numAssemblers;
        return (0, bigmath_1.scaleBigInt)(numAssemblers, game.calculateBoost(assemblerName, state));
    });
    return (0, bigmath_1.bigSum)(pairs);
}
const ABSOLUTE_MAX_CRAFT = (0, bigmath_1.NumToBig)(2);
const maxCraftAtATime = {
    "copper-ore": 2,
    "iron-ore": 2,
    coal: 2,
    stone: 2,
    begin: 1,
    "wizard-degree": 100,
    "wizard-essence": 10,
    // money: (game, state) => bigMax(ABSOLUTE_MAX_CRAFT, maxCraftByAssemblerSpeed(game, state, "money")),
    bank: (game, state) => (0, bigmath_1.bigFloor)((0, bigmath_1.bigMax)(ABSOLUTE_MAX_CRAFT, 10n * (state.assemblers["money"]?.["bank"] ?? 0n) / bigmath_1.SCALE_N)),
};
const m = (0, smap_1.fromPairs)((0, smap_1.mapPairs)(maxCraftAtATime, (amount, item) => {
    if (typeof amount === "number")
        return [item, (0, bigmath_1.NumToBig)(amount)];
    return [item, amount];
}));
exports.default = {
    ABSOLUTE_MAX_CRAFT,
    maxCraftAtATime: m,
};
